import React, { Component, Fragment } from "react";
import { PropTypes } from "prop-types";
import { FormGroup, Button, Col, Row, FormControl, ControlLabel, Tabs, Tab, } from "react-bootstrap";
import Select from "react-select";
import debounce from "lodash/debounce";
import moment from "moment";
import { NotificationManager } from "react-notifications";
import AdminService from "../../../services/AdminService";
import SkillsService from "../../../services/SkillsService";
import AreasService from "../../../services/AreasService";
import SearchService from "../../../services/SearchService";
import RolesService from "../../../services/RolesService";
import CountriesService from "../../../services/CountriesService";
import SalariesService from "../../../services/SalariesService";
import PaymentConditionService from "../../../services/PaymentConditionService";
import HandleError from "../../../services/HandleError";
import CustomerFields from "./fields/CustomerFields";
import EmployeeFields from "./fields/EmployeeFields";
import SalaryFields from "./fields/SalaryFields";
import SkillsContainer from "../../partials/skills/Container";
import AreasContainer from "../../partials/areas/Container";
import LoaderInline from "../../helpers/LoaderInline";
import LoadingSVG from "../../helpers/LoadingSVG";
import InlineError from "../../messages/InlineError";
import SuperAdminFields from "./fields/SuperAdminFields";
import { dataToSelectOption } from "../../helpers/HelperFunctions";
import { hasRole } from "../../helpers/Permissions";

class UserEditForm extends Component {

	state = {
		selectedRoles: "",
		selectedRole: null,
		selectedUser: null,
		selectedPayment: null,
		isAssistant: null,
		isLoadingUser: true,
		isLoadingRoles: true,
		isUpdatingUser: false,
		receivesLogEmails: false,
		statuses: [],
		skills: [],
		areas: [],
		currencies: [],
		paymentConditions: [],
		formData: { skills: [], areas: [], salaries: [], receives_log_emails: true },
		sId: 0,
		errors: {},
	}

	componentDidMount = () => {
		const { userId } = this.props.match.params;
		this.getUser(userId);
		this.getRoles();
		this.getCountries();
		// this.setState({ isAssistant: hasRole(6) });
	}

	onChange = (e) => { this.setState({ formData: { ...this.state.formData, [e.target.name]: e.target.value || null } }); };

	onSelectChange = (option, name) => {
		if (option !== null) {
			this.setState({ formData: { ...this.state.formData, [name]: option.value || "" } });
		}
	};

	onCheckboxChange = (e) => {
		this.setState({ ...this.state, receivesLogEmails: e.target.checked, formData: { ...this.state.formData, [e.target.name]: e.target.checked } });
	}

	onWorkDateChange = (date, name, selectedDate) => {
		if (date) {
			const formatedDate = moment(date).format("YYYY-MM-DD");
			this.setState({
				[selectedDate]: date.toISOString(),
				formData: {
					...this.state.formData,
					[name]: formatedDate
				}
			});
		} else {
			this.setState({
				[selectedDate]: null,
				formData: {
					...this.state.formData,
					[name]: null
				}
			});
		}
	}

	onRoleSelectChange = (option) => {
		if (option !== null) {
			this.setState({
				...this.state,
				errors: {},
				selectedRole: parseInt(option, 10),
				selectedRoles: option,
				formData: { ...this.state.formData, role_id: option.split(",") },
			});

			if (option == 3) { // eslint-disable-line
				this.getAreasAndPayments();
			}

			if (option == 2 || option == 4) { // eslint-disable-line
				this.getSkills();
				this.getCurrencies();
			}
		}
	};

	onPaymentSelectChange = (option, name) => {
		if (option !== null) {
			this.setState({ selectedPayment: option, formData: { ...this.state.formData, [name]: option.value || "" } });
		} else {
			this.setState({ selectedPayment: null, formData: { ...this.state.formData, [name]: null } });
		}
	}


	onAsyncChange = (option, name) => {
		if (option !== null) {
			this.setState({ selectedUser: option, formData: { ...this.state.formData, [name]: option.id || "" } });
		} else {
			this.setState({ selectedUser: null, formData: { ...this.state.formData, [name]: null } });
		}
	};

	onChangeSkillValue = (e, skill) => {
		this.setState({
			formData: {
				...this.state.formData,
				skills: this.state.formData.skills.map((item) => (
					item.id !== skill.id ? item
						:
						{
							id: skill.id,
							name: skill.name,
							value: parseInt(e.target.value, 10)
						}
				))
			}
		});
	}

	onChangeAreaValue = (e, area) => {
		this.setState({
			formData: {
				...this.state.formData,
				areas: this.state.formData.areas.map((item) => (
					item.id !== area.id ? item
						:
						{
							id: area.id,
							name: area.name,
							value: parseFloat(e.target.value) >= 0 ? parseFloat(e.target.value) : 0,
						}
				))
			}
		});
	}

	onChangeSalaryValue = (e, salary) => {
		this.setState({
			formData: {
				...this.state.formData,
				salaries: this.state.formData.salaries.map((item) => (
					item.id !== salary.id ? item : {
						...item,
						domestic_salary: parseInt(e.target.value, 10),
					}
				))
			}
		});
	}

	onChangeSalaryCurrency = (option, salary) => {
		this.setState({
			formData: {
				...this.state.formData,
				salaries: this.state.formData.salaries.map((item) => (
					item.id !== salary.id ? item : {
						...item,
						currency: option.value,
					}
				))
			}
		});
	}

	onFromDateChange = (date, salary) => {
		if (date) {
			this.setState({
				formData: {
					...this.state.formData,
					salaries: this.state.formData.salaries.map((item) => (
						item.id !== salary.id ? item : {
							...item,
							from: moment(date).format("YYYY-MM-DD"),
							selectedFromDate: date.toISOString()
						}
					))
				}
			});
		}
	}

	onSubmit = (e) => {
		e.preventDefault();
		const { userId } = this.props.match.params;
		this.setState({ isUpdatingUser: true, errors: {} });
		this.adminService.update(userId, this.state.formData).then((res) => {
			NotificationManager.success("User updated.", "Success!");
			this.props.history.push("/users");
		}).catch((err) => {
			this.setState({ isUpdatingUser: false });
			HandleError(err, this);
		});
	}

	getRoles = () => {
		this.rolesService.index(0).then((res) => {
			this.setState({
				isLoadingRoles: false,
				roles: this.mapRolesToSelectOptions(res.data)
			});
		}).catch((err) => {
			this.setState({ isLoadingRoles: false });
			HandleError(err, this);
		});
	}

	getCountries = () => {
		this.countriesService.index(0).then((res) => {
			this.setState({
				isLoadingCountries: false,
				countries: this.mapDataToSelectOption(res.data)
			});
		}).catch((err) => {
			this.setState({ isLoadingCountries: false });
			HandleError(err, this);
		});
	}

	getSkills = () => {
		const { skills } = this.state;
		if (skills && Array.isArray(skills) && skills.length < 1) {
			this.setState({ isLoadingSkills: true });
			this.skillsService.index().then((res) => {
				this.setState({ isLoadingSkills: false, skills: this.loadUserSkills(res.data.skills) });
			}).catch((err) => {
				this.setState({ isLoadingSkills: false });
				HandleError(err, this);
			});
		}
	}

	getCurrencies = () => {
		const { currencies } = this.state;
		if (currencies && Array.isArray(currencies) && currencies.length < 1) {
			this.setState({ isLoadingCurrencies: true });
			new SalariesService(this, "/currencies").index(0).then((res) => {
				this.setState({
					isLoadingCurrencies: false,
					currencies: this.loadCurrencies(res.data)
				});
			}).catch((err) => {
				this.setState({ isLoadingCurrencies: false });
				HandleError(err, this);
			});
		}
	}

	getAreasAndPayments = () => {
		const { areas } = this.state;
		if (areas && Array.isArray(areas) && areas.length < 1) {
			this.setState({ isLoadingAreas: true });
			this.areasService.index().then((res) => {
				this.setState({
					isLoadingAreas: false,
					areas: this.loadUserAreas(res.data.areas),
					paymentConditions: this.mapPaymentsToSelectOptions(res.data.conditions)
				});
			}).catch((err) => {
				this.setState({ isLoadingAreas: false });
				HandleError(err, this);
			});
		}
	}

	getUser = (userId) => {
		this.adminService.show(userId).then((res) => {
			const user = { ...res.data.user };
			const role = (user.roles && Array.isArray(user.roles) && user.roles[0] ? user.roles[0].id : null);
			this.setState({
				...this.state,
				user_id: user.id,
				isLoadingUser: false,
				selectedRole: role,
				selectedRoles: this.loadUserRolesToString(user.roles),
				formData: {
					...this.state.formData,
					first_name: user.first_name,
					last_name: user.last_name,
					email: user.email,
					skype_name: user.skype_name,
					cellular: user.cellular,
					status_id: user.status_id,
					country_id: user.country_id,
					role_id: this.loadUserRolesToString(user.roles).split(","),
					address: this.loadAttributeByName(user.attributes, "address"),
					emergency_contact: this.loadAttributeByName(user.attributes, "emergency_contact"),
				},
			});

			// if user is super admin , load superadmin fields and fill them with data
			if (role === 1) {
				this.loadSuperAdminFields(res.data.reports_to_user);
			}

			// if user is employee or admin, load employee/admin fields and  them with data
			else if (role === 2 || role === 4) {
				this.getCurrencies();
				this.loadEmployeOrAdminFields(user, res.data.availableSkills, res.data.reports_to_user);
			}

			// if user is customer, load customer fields and fill  them with data
			else if (role === 3) {
				this.loadCustomerFields(user, res.data.availableAreas, res.data.availablePayments);
			}

			this.props.passUserToParent(user.full_name || "");
		}).catch((err) => {
			this.setState({ isLoadingUser: false });
			HandleError(err, this);
		});
	}

	loadSingleField = (field) => field || null

	loadUserSkills = (skills) => {
		if (skills && Array.isArray(skills)) {
			return skills.map((item) => ({ id: item.id, name: item.name, value: item.pivot ? item.pivot.value : null }));
		}
		return [];
	}

	loadCurrencies = (currencies) => {
		if (currencies && Array.isArray(currencies)) {
			return currencies.map((item) => dataToSelectOption(item, "value", item, "label"));
		}
		return [];
	}

	loadUserAreas = (areas) => {
		if (areas && Array.isArray(areas)) {
			return areas.map((item) => ({ id: item.id, name: item.name, value: item.pivot ? item.pivot.price : 0 }));
		}
		return [];
	}

	loadSuperAdminFields = (reports_to_user) => {
		this.setState({
			...this.state,
			selectedUser: (reports_to_user && dataToSelectOption(reports_to_user.id, "id", reports_to_user.full_name, "full_name"))
		});
	}

	loadEmployeOrAdminFields = (user, availableSkills, reports_to_user) => {
		this.setState({
			...this.state,
			formData: {
				...this.state.formData,
				skills: this.loadUserSkills(user.skills),
				title: this.loadAttributeByName(user.attributes, "title"),
				start_date: this.loadAttributeByName(user.attributes, "start_date"),
				end_date: this.loadAttributeByName(user.attributes, "end_date"),
				insurance_nr: this.loadAttributeByName(user.attributes, "insurance_nr"),
				personal_code: this.loadAttributeByName(user.attributes, "personal_code"),
				bank_account: this.loadAttributeByName(user.attributes, "bank_account"),
				reporter_id: reports_to_user && reports_to_user.id,
				salaries: this.loadUserSalaries(user.salaries),
				receives_log_emails: user.receives_log_emails
			},
			selectedStartDate: moment(this.loadAttributeByName(user.attributes, "start_date")).toISOString(),
			selectedEndDate: moment(this.loadAttributeByName(user.attributes, "end_date")).toISOString(),
			receivesLogEmails: (user && user.receives_log_emails) ? user.receives_log_emails : false,
			skills: (availableSkills !== null ? this.loadUserSkills(availableSkills) : []),
			selectedUser: (reports_to_user && dataToSelectOption(reports_to_user.id, "id", reports_to_user.full_name, "full_name"))
		});
	}

	loadCustomerFields = (user, availableAreas, availablePayments) => {
		const paymentCondition = (user.payment_conditions && Array.isArray(user.payment_conditions) && user.payment_conditions[0] ? user.payment_conditions[0] : null);
		this.setState({
			...this.state,
			formData: {
				...this.state.formData,
				areas: this.loadUserAreas(user.areas),
				full_company_name: this.loadAttributeByName(user.attributes, "full_company_name"),
				administrator: this.loadAttributeByName(user.attributes, "administrator"),
				administrator_email: this.loadAttributeByName(user.attributes, "administrator_email"),
				point_of_reference_email: this.loadAttributeByName(user.attributes, "point_of_reference_email"),
				point_of_reference_cel: this.loadAttributeByName(user.attributes, "point_of_reference_cel"),
				priority_level: this.loadAttributeByName(user.attributes, "priority_level"),
				pay_con_id: (paymentCondition && paymentCondition.id)
			},
			areas: (availableAreas && this.loadUserAreas(availableAreas)),
			paymentConditions: (availablePayments && this.mapPaymentsToSelectOptions(availablePayments)),
			selectedPayment: (paymentCondition && dataToSelectOption(paymentCondition.id, "value", `${paymentCondition.days} days`, "label")),
		});
	}

	loadAttributeByName = (attributes, name) => {
		let attribute = null;
		if (attributes && Array.isArray(attributes)) {
			attribute = attributes.find((item) => (item.name === name));
		}
		if (attribute && attribute.value) { return attribute.value; }
		return null;
	}

	loadUserSalaries = (salaries) => {
		if (salaries && Array.isArray(salaries)) {
			return salaries.map((salary) => ({
				id: salary.id,
				from: salary.from,
				domestic_salary: salary.domestic_salary,
				currency: salary.currency,
				selectedFromDate: moment(salary.from).toISOString(),
			}));
		}
		return [];
	}

	loadUserRolesToString = (roles) => {
		if (roles && Array.isArray(roles)) {
			const roleNames = roles.map((item) => item.id);
			return roleNames.toString();
		}
		return "";
	}

	mapPaymentsToSelectOptions = (payments) => {
		if (payments && Array.isArray(payments)) {
			return payments.map((item) => ({ value: item.id, label: `${item.days} days` }));
		}
		return [];
	}

	mapRolesToSelectOptions = (roles) => {
		if (roles && Array.isArray(roles)) {
			return roles.map((item) => ({ value: item.id, label: item.slug, type: item.type }));
		}
		return [];
	}

	mapDataToSelectOption = (countries) => {
		if (countries && Array.isArray(countries)) {
			return countries.map((item) => dataToSelectOption(item.id, "value", item.name, "label"));
		}
		return [];
	}

	dropedNewSkill = (newSkill) => {
		this.setState((prevState) => ({
			skills: prevState.skills.filter((val, i) => (i !== newSkill.index)),
			formData: {
				...this.state.formData,
				skills: [...this.state.formData.skills, newSkill.skill]
			}
		}));
	}

	removeNewSkill = (removedSkill, index) => {
		this.setState((prevState) => ({
			skills: [...this.state.skills, removedSkill],
			formData: {
				...this.state.formData,
				skills: prevState.formData.skills.filter((val, i) => (i !== index)),
			}
		}));
	}

	dropedNewArea = (newArea) => {
		this.setState((prevState) => ({
			areas: prevState.areas.filter((val, i) => (i !== newArea.index)),
			formData: {
				...this.state.formData,
				areas: [...this.state.formData.areas, newArea.area]
			}
		}));
	}

	removeNewArea = (removedArea, index) => {
		this.setState((prevState) => ({
			areas: [...this.state.areas, removedArea],
			formData: {
				...this.state.formData,
				areas: prevState.formData.areas.filter((val, i) => (i !== index)),
			}
		}));
	}

	addNewSalary = () => {
		this.setState((prevState) => ({
			sId: prevState.sId - 1,
			formData: {
				...this.state.formData,
				salaries: [...this.state.formData.salaries, {
					id: prevState.sId - 1,
					from: moment().format("YYYY-MM-DD"),
					selectedFromDate: moment(),
					domestic_salary: "",
					currency: null,
				}]
			}
		}));
	}

	handleAsyncSearch = (input = null, attribute, extra, callback) => {
		if (!input || !input.replace(/\s/g, "").length) {
			callback(null, { complete: true });
			return;
		}
		this.asyncCallback(input, attribute, extra, callback);
	}

	asyncCallback = debounce((input, attribute, extra, callback) => {
		this.searchService.searchByAttribute(attribute, input, extra).then((res) => {
			callback(null, { options: res.data, complete: true });
		}).catch((err) => {
			HandleError(err);
			callback(null, { complete: true });
		});
	}, 700);

	paymentService = new PaymentConditionService(this);
	adminService = new AdminService(this, "users");
	areasService = new AreasService(this, "?conditions=true")
	skillsService = new SkillsService(this, "?getStatus=true");
	searchService = new SearchService(this);
	rolesService = new RolesService(this, "/get")
	countriesService = new CountriesService(this)

	render() {
		const {
			selectedRole, selectedUser, selectedPayment, isLoadingAreas, isLoadingSkills, isLoadingUser, isUpdatingUser, isLoadingRoles, isLoadingCurrencies, isLoadingCountries,
			formData, errors, skills, currencies, paymentConditions, areas, receivesLogEmails, user_id, roles, selectedRoles, countries, isAssistant
		} = this.state;
		return (
			<Fragment>
				<form onSubmit={this.onSubmit}>
					{isLoadingUser ? <LoadingSVG /> :
						<Fragment>
							<Tabs defaultActiveKey={1} id="user-edit-tab" className="card-tab" onSelect={this.handleSelect}>
								<Tab eventKey={1} title="User details">
									<Row>
										<Fragment>
											<Col md={6} sm={6} xs={12}>
												{/* General fields for all types of users */}
												<Row>
													<Col md={6}>
														<FormGroup validationState={errors.first_name && "error"}>
															<ControlLabel>First Name</ControlLabel>
															<FormControl type="text" name="first_name" placeholder="Enter first name" value={formData.first_name || ""} onChange={this.onChange} />
															{errors.first_name && <InlineError text={errors.first_name} />}
														</FormGroup>
													</Col>
													<Col md={6}>
														<FormGroup validationState={errors.last_name && "error"}>
															<ControlLabel>Last Name</ControlLabel>
															<FormControl type="text" name="last_name" placeholder="Enter last name" value={formData.last_name || ""} onChange={this.onChange} />
															{errors.last_name && <InlineError text={errors.last_name} />}
														</FormGroup>
													</Col>
												</Row>
												<Row>
													<Col md={6}>
														<FormGroup validationState={errors.email && "error"}>
															<ControlLabel>Email</ControlLabel>
															<FormControl type="email" name="email" placeholder="Enter email" value={formData.email || ""} onChange={this.onChange} />
															{errors.email && <InlineError text={errors.email} />}
														</FormGroup>
													</Col>
													<Col md={6}>
														<FormGroup validationState={errors.country_id && "error"}>
															<ControlLabel>Country</ControlLabel>
															<Select
																onChange={(option) => { this.onSelectChange(option, "country_id"); }}
																name="country_id"
																placeholder="Choose country"
																value={formData.country_id || ""}
																options={countries}
																isLoading={isLoadingCountries}
																clearable={false}
																multi={false}
															/>
															{errors.country_id && <InlineError text={errors.country_id} />}
														</FormGroup>
													</Col>
												</Row>
												<Row>
													<Col md={6}>
														<FormGroup validationState={errors.password && "error"}>
															<ControlLabel>Password</ControlLabel>
															<FormControl type="password" name="password" placeholder="Enter password" value={formData.password || ""} onChange={this.onChange} />
															{errors.password && <InlineError text={errors.password} />}
														</FormGroup>
													</Col>
													<Col md={6}>
														<FormGroup validationState={errors.password_confirmation && "error"}>
															<ControlLabel>Confirm Password</ControlLabel>
															<FormControl type="password" name="password_confirmation" placeholder="Enter password" value={formData.password_confirmation || ""} onChange={this.onChange} />
															{errors.password_confirmation && <InlineError text={errors.password_confirmation} />}
														</FormGroup>
													</Col>
												</Row>
												<Row>
													<Col md={6}>
														<FormGroup validationState={errors.skype_name && "error"}>
															<ControlLabel>Skype</ControlLabel>
															<FormControl type="text" name="skype_name" placeholder="Enter skype name" value={formData.skype_name || ""} onChange={this.onChange} />
															{errors.skype_name && <InlineError text={errors.skype_name} />}
														</FormGroup>
													</Col>
													<Col md={6}>
														<FormGroup validationState={errors.cellular && "error"}>
															<ControlLabel>Cellular</ControlLabel>
															<FormControl type="text" name="cellular" placeholder="Enter telephone" value={formData.cellular || ""} onChange={this.onChange} />
															{errors.cellular && <InlineError text={errors.cellular} />}
														</FormGroup>
													</Col>
												</Row>
												<Row>
													<Col md={6}>
														<FormGroup validationState={errors.address && "error"}>
															<ControlLabel>Address</ControlLabel>
															<FormControl type="text" name="address" placeholder="Enter full address" value={formData.address || ""} onChange={this.onChange} />
															{errors.address && <InlineError text={errors.address} />}
														</FormGroup>
													</Col>
													<Col md={6}>
														<FormGroup validationState={errors.emergency_contact && "error"}>
															<ControlLabel>Emergency Contact</ControlLabel>
															<FormControl type="text" name="emergency_contact" placeholder="Enter emergency contact" value={formData.emergency_contact || ""} onChange={this.onChange} />
															{errors.emergency_contact && <InlineError text={errors.emergency_contact} />}
														</FormGroup>
													</Col>
												</Row>
												<Row>
													<Col md={6}>
														<FormGroup validationState={errors.status_id && "error"}>
															<ControlLabel>Status</ControlLabel>
															<Select
																onChange={(option) => { this.onSelectChange(option, "status_id"); }}
																name="status_id"
																placeholder="Choose user status"
																value={formData.status_id || ""}
																options={[{ label: "Active", value: 4 }, { label: "Inactive", value: 5 }]}
																clearable={false}
																multi={false}
															/>
															{errors.status_id && <InlineError text={errors.status_id} />}
														</FormGroup>
													</Col>
													<Col md={6}>
														<FormGroup validationState={errors.role_id && "error"}>
															<ControlLabel>Role</ControlLabel>
															<Select
																onChange={(option) => { this.onRoleSelectChange(option, "role_id"); }}
																name="role_id"
																placeholder="Choose user role"
																value={selectedRoles}
																options={roles}
																isLoading={isLoadingRoles}
																clearable={false}
																closeOnSelect
																multi
																required
																simpleValue
															/>
															{errors.role_id && <InlineError text={errors.role_id} />}
														</FormGroup>
													</Col>
												</Row>
												{/* end of general fields */}

												{/* Dynamic fields, based on role that has been selected.
												If selected role is "SuperAdmin" them show superadmin fields */}
												{selectedRole === 1 &&
													<SuperAdminFields
														user_id={user_id}
														formData={formData}
														errors={errors}
														selectedUser={selectedUser}
														handleAsyncSearch={this.handleAsyncSearch}
														onSelectChange={this.onSelectChange}
														onAsyncChange={this.onAsyncChange}
														onChange={this.onChange}
													/>
												}

												{/* If selected role is "Employee or Admin" then show Employee fields */}
												{(selectedRole === 2 || selectedRole === 4) &&
													<EmployeeFields
														isEditPage
														user_id={user_id}
														formData={formData}
														errors={errors}
														selectedUser={selectedUser}
														receivesLogEmails={receivesLogEmails}
														onChange={this.onChange}
														selectedStartDate={this.state.selectedStartDate}
														selectedEndDate={this.state.selectedEndDate}
														handleAsyncSearch={this.handleAsyncSearch}
														onSelectChange={this.onSelectChange}
														onAsyncChange={this.onAsyncChange}
														onWorkDateChange={this.onWorkDateChange}
														onCheckboxChange={this.onCheckboxChange}
													/>
												}

												{/* If selected role is "Customer" then show Customer fields. */}
												{selectedRole === 3 &&
													<CustomerFields
														formData={formData}
														errors={errors}
														selectedPayment={selectedPayment}
														paymentConditions={paymentConditions}
														onPaymentSelectChange={this.onPaymentSelectChange}
														onChange={this.onChange}
													/>
												}
											</Col>

											<Col md={6} sm={6} xs={12}>
												{/* if selected role is "admin or employee", show skills DND in right side */}
												{(selectedRole === 4 || selectedRole === 2) &&
													<Fragment>
														<span className="column-title">Skills</span>
														<div className="skills-container">
															<div className="all-skills">
																{isLoadingSkills ?
																	<Fragment>
																		<LoadingSVG />
																	</Fragment>
																	:
																	<Fragment>
																		<SkillsContainer
																			allSkills={skills}
																			userSkills={formData.skills}
																			errors={errors}
																			onChangeSkillValue={this.onChangeSkillValue}
																			dropedNewSkill={this.dropedNewSkill}
																			removeNewSkill={this.removeNewSkill}
																		/>
																	</Fragment>
																}
															</div>
														</div>
													</Fragment>
												}
												{/* if selected role is "customer", show areas DND in right side */}
												{selectedRole === 3 &&
													<Fragment>
														<span className="column-title">Areas</span>
														<div className="skills-container">
															<div className="all-skills">
																{isLoadingAreas ?
																	<Fragment>
																		<LoadingSVG />
																	</Fragment>
																	:
																	<Fragment>
																		<AreasContainer
																			allAreas={areas}
																			areas={formData.areas}
																			errors={errors}
																			paymentConditions={paymentConditions}
																			onChangeAreaValue={this.onChangeAreaValue}
																			dropedNewArea={this.dropedNewArea}
																			removeNewArea={this.removeNewArea}
																		/>
																	</Fragment>
																}
															</div>
														</div>
													</Fragment>
												}
											</Col>
										</Fragment>
									</Row>
								</Tab>
								{(selectedRole === 2 || selectedRole === 4) &&
									<Tab eventKey={2} title="Salaries" disabled={isAssistant}>
										<SalaryFields
											formData={formData}
											errors={errors}
											currencies={currencies}
											isLoadingCurrencies={isLoadingCurrencies}
											onChangeSalaryValue={this.onChangeSalaryValue}
											onChangeSalaryCurrency={this.onChangeSalaryCurrency}
											onFromDateChange={this.onFromDateChange}
											addNewSalary={this.addNewSalary}
										/>
									</Tab>
								}
							</Tabs>
							<Row>
								<Col md={12} sm={12} xs={12}>
									<Button className="btn-crud" bsStyle="primary" disabled={isUpdatingUser} type="submit">{isUpdatingUser ? "Updating..." : "Update"}</Button>
									{isUpdatingUser ? <LoaderInline width="30" height="30" color="#2196f3" /> : null}
								</Col>
							</Row>
						</Fragment>
					}
				</form>
			</Fragment>
		);
	}
}

UserEditForm.propTypes = {
	match: PropTypes.shape({
		params: PropTypes.shape({
			userId: PropTypes.string.isRequired,
		}).isRequired,
	}).isRequired,
	history: PropTypes.shape({
		push: PropTypes.func.isRequired
	}).isRequired,
	passUserToParent: PropTypes.func.isRequired,
};
export default UserEditForm;


// WEBPACK FOOTER //
// ./src/components/forms/users/UserEditForm.js